import React, { FC } from 'react';
import dynamic from 'next/dynamic';
import { IHomeServerProps } from '@base/shop/interface';
import { IBrandFeaturesConfig } from '@pro/brand/interface';
import { useBrandPage } from '@pro/brand/useBrandPage';
import BaseLayout from '@app/common/BaseLayout';

const OldHomePage = dynamic(() => import('@app/shop/OldHomePage'), { ssr: true });
const BrandFeatures = dynamic(() => import('@pro/brand/BrandFeaturesV3'), { ssr: true });

const NewHomePage: FC<IBrandFeaturesConfig> = props => {
    useBrandPage();

    return <BrandFeatures {...props} />
}

const HomePage: Globals.NextPage<IHomeServerProps> = ({ serverProps }) => {
    return 'features' in serverProps
        ? (
            <BaseLayout
                openingPopupProps={{
                    fixedRegisterProps: {
                        defaultExpand: false,
                    }
                }}
            >
                <NewHomePage {...serverProps} />
            </BaseLayout>
        )
        : (
            <BaseLayout>
                <OldHomePage {...serverProps} />
            </BaseLayout>
        )
};

HomePage.pageConf = {
    pageCode: 'index',
    bodyClassName: 'bg-light',
};

HomePage.getLayout = page => page;

export { getServerSideProps } from '@pro/shop/services';

export default HomePage;
